import dayjs from 'dayjs';

const FormatDate = (date: any): any => {
  if(!date) return "N/A";
  return dayjs(date).format('DD-MMM-YYYY  HH:mm:ss');
};

export default FormatDate;
